import type { ConditionType, HeliosConditionsBaseState, HeliosConditionsState } from '../index';

export const setConditions = (
  state: HeliosConditionsState,
  {
    payload,
  }: {
    payload: {
      data: HeliosConditionsBaseState | null;
      type: ConditionType;
    };
  }
) => {
  state[payload.type] = payload.data as unknown as HeliosConditionsState[ConditionType];
};
